import WrapperWithSidebar from './WrapperWithSidebar';

export default WrapperWithSidebar;
